"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var clsPrefix = 'kui-input';

var Input = function Input(_ref) {
  var _classNames;

  var type = _ref.type,
      size = _ref.size,
      disabled = _ref.disabled,
      error = _ref.error,
      name = _ref.name,
      value = _ref.value,
      placeholder = _ref.placeholder,
      onChange = _ref.onChange,
      control = _ref.control,
      onKeyPress = _ref.onKeyPress,
      onBlur = _ref.onBlur,
      style = _ref.style,
      className = _ref.className,
      onFocus = _ref.onFocus,
      setRef = _ref.setRef; // REVIEW:control 为显性受控属性，如果有 value 或 onChange 则认为是受控 

  var _control = control || typeof value !== 'undefined';

  var _useState = (0, React.useState)(fixedControlValue(value)),
      _useState2 = _slicedToArray(_useState, 2),
      stateValue = _useState2[0],
      setStateValue = _useState2[1];

  var _useState3 = (0, React.useState)(fixedControlValue(value)),
      _useState4 = _slicedToArray(_useState3, 2),
      prevValue = _useState4[0],
      setPrevValue = _useState4[1]; // 有啥用？


  if (prevValue !== fixedControlValue(value) && _control) {
    // 如果受控，不用 stateValue
    setPrevValue(fixedControlValue(value));
  }

  var realValue = _control ? fixedControlValue(value) : stateValue;

  function fixedControlValue(value) {
    if (typeof value === 'undefined' || value === null) {
      return '';
    }

    return value;
  }

  function handleKeyPress(event) {
    onKeyPress === null || onKeyPress === void 0 ? void 0 : onKeyPress(event, realValue);
  }

  function handleBlur(event) {
    onBlur === null || onBlur === void 0 ? void 0 : onBlur({
      value: event.target.value,
      name: name
    });
  }

  function handleChange(e) {
    if (!_control) {
      setStateValue(e.target.value);
    }

    if (_control && stateValue) {
      setStateValue('');
    }

    onChange === null || onChange === void 0 ? void 0 : onChange({
      value: e.target.value,
      name: name
    });
  }

  var cls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, clsPrefix, true), _defineProperty(_classNames, "".concat(clsPrefix, "-disabled"), !!disabled), _defineProperty(_classNames, "".concat(clsPrefix, "-error"), !!error), _defineProperty(_classNames, "".concat(clsPrefix, "-").concat(size), true), _classNames), className);
  return /*#__PURE__*/React.createElement("input", {
    className: cls,
    type: type,
    name: name,
    value: realValue,
    placeholder: placeholder,
    disabled: disabled,
    onBlur: handleBlur,
    onChange: handleChange,
    onKeyDown: handleKeyPress,
    style: style,
    onFocus: onFocus,
    ref: function ref(el) {
      setRef === null || setRef === void 0 ? void 0 : setRef(el);
    }
  });
};

Input.defaultProps = {
  type: 'text',
  size: 'normal',
  disabled: false,
  error: false,
  name: '',
  placeholder: '',
  control: false,
  onBlur: null,
  onChange: null,
  onKeyPress: null,
  style: {},
  className: ''
};
var _default = Input;
exports["default"] = _default;